import isMigrateFromElexys from "@/app/infrastructures/misc/common-library/IsMigrateFromElexys";

const addPrefixGenesis = () => {
  return isMigrateFromElexys() ? "Genesis" : "";
};
export default addPrefixGenesis;
